import * as React from 'react';
import type { BasketButtonModelProps } from '~/Partials/Nav/Components/BasketButton/BasketButtonModel';
import { useBasketButtonModel } from '~/Partials/Nav/Components/BasketButton/BasketButtonModel';

interface BasketStateObserverProps extends BasketButtonModelProps {
    onStateChanged: (isApplicationInProgress: boolean, linkUrl: string) => void;
}

export const BasketStateObserver: React.FC<React.PropsWithChildren<BasketStateObserverProps>> = props => {
    const { onStateChanged, ...otherProps } = props;
    const { isApplicationInProgress, basketLinkUrl } = useBasketButtonModel(otherProps);

    React.useEffect(() => {
        onStateChanged(isApplicationInProgress, basketLinkUrl);
    }, [isApplicationInProgress, basketLinkUrl]);

    return null;
};
